import { render, staticRenderFns } from "./qatar-oman-kuwait-saudi-arabia-projects.vue?vue&type=template&id=407e7111&"
import script from "./qatar-oman-kuwait-saudi-arabia-projects.vue?vue&type=script&lang=js&"
export * from "./qatar-oman-kuwait-saudi-arabia-projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports